import React from "react";
import { Gem, Users, Leaf, ShieldCheck } from "lucide-react";
import { aboutBlock, values } from "../mock";
import { Reveal } from "../hooks/useReveal";

const valueIcons = [Gem, Users, Leaf, ShieldCheck];

export default function Values() {
  return (
    <section className="relative">
      {/* Image + quote band */}
      <div className="relative h-[70vh] md:h-[85vh] overflow-hidden">
        <img src={aboutBlock.image} alt="South Sea interior" className="h-full w-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(14,35,56,0.75) 0%, rgba(14,35,56,0.35) 55%, rgba(14,35,56,0.15) 100%)" }} />
        <div className="absolute inset-0 max-w-[1500px] mx-auto px-6 md:px-10 flex items-center">
          <Reveal className="max-w-2xl">
            <p className="font-sans-ui tracking-wide-2 text-[0.66rem] uppercase mb-6" style={{ color: "var(--sand)" }}>
              {aboutBlock.eyebrow} — {aboutBlock.title}
            </p>
            <h2 className="font-serif-display text-cream text-[2.6rem] md:text-[4rem] leading-[1.05] font-300" style={{ color: "var(--cream)" }}>
              {aboutBlock.quote}
            </h2>
            <p className="mt-8 text-cream/85 text-base md:text-lg leading-relaxed max-w-xl" style={{ color: "rgba(246,243,238,0.85)" }}>
              {aboutBlock.body}
            </p>
          </Reveal>
        </div>
      </div>

      {/* Values */}
      <div className="bg-[var(--navy-900)]" style={{ backgroundColor: "var(--navy-900)" }}>
        <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-16 md:py-20 grid grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-8">
          {values.map((v, i) => {
            const Icon = valueIcons[i];
            return (
              <Reveal key={v.title} delay={i * 90} className="text-center md:text-left">
                <Icon size={26} strokeWidth={1.2} style={{ color: "var(--teal-light)" }} className="mx-auto md:mx-0 mb-5" />
                <h3 className="font-sans-ui tracking-wide-3 text-sm uppercase text-cream mb-2" style={{ color: "var(--cream)" }}>{v.title}</h3>
                <p className="text-sm text-cream/60" style={{ color: "rgba(246,243,238,0.6)" }}>{v.description}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
